// @ts-check
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { getPartnerAction } from '../redux/actions/partner-actions';
import { PartnerComponent } from '../components/partner-info-component';
import Grid from '@material-ui/core/Grid';

import { makeStyles } from '@material-ui/core/styles';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

import { LoadingComponent } from '../components/loading-component';

import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';
import { PartnerMapComponent } from '../components/partner-map-component';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  sectionHeading: {
    margin: theme.spacing(3)
  },
  clientHeader: {
    textAlign: 'center'
  },
  clientLogo: {
    height: '10rem',
    width: '10rem',
    objectFit: 'contain'
  },
  large: {
    height: '8rem',
    width: '8rem',
    objectFit: 'contain'
  },

  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  }
}));

function Partner({ partner }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <PartnerMapComponent partner={partner} />
      </Grid>

      <Grid item xs={12} md={8}>
        <PartnerComponent partner={partner} />
      </Grid>
    </Grid>
  );
}

export default function PartnerPage() {
  // @ts-ignore
  const { id } = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { partner, loading, success } = useSelector((state) => state.partner);

  useEffect(() => {
    dispatch(getPartnerAction(id));
  }, [dispatch, id]);

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        <Container className={classes.container}>
          {loading && <LoadingComponent />}
          {!loading && success && (
            <>
              <BackNavigationComponent
                page="Partner"
                uri="/partners"
                path={[
                  {
                    page: 'Home',
                    uri: '/'
                  },
                  {
                    page: 'Partners',
                    uri: '/partners'
                  }
                ]}
              />
              <Partner partner={partner} />
            </>
          )}
        </Container>
      </React.Fragment>
    </>
  );
}
